import React from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
import moment from 'moment';
import utils from '../../../lib/utils';

const ShippingBox = ({ boxDetails }) => {
  const isDate = dateStr => {
    var formats = [moment.ISO_8601, 'MM/DD/YYYY  :)  HH*mm*ss'];
    return moment(dateStr, formats, true).isValid();
  };
  return (
    <div>
      <h1 className="shipping-header">Shipping and Tracking</h1>
      {Object.entries(boxDetails.trackingInfo).map(([key, val]) => {
        const value = isDate(val) ? utils.getDateTimeFormat(val, 'regular') : val;
        return (
          <Row row className="shipping-row">
            <Label for="carrier" sm={4}>
              {utils.toTitleCase(key)}:
            </Label>
            <Col sm={8}>
              <Input type="text" disabled value={value} />
            </Col>
          </Row>
        );
      })}
      <h1 className="shipping-header">Shipped To Address</h1>
      {Object.entries(boxDetails.shippedAddress).map(([key, val]) => {
        return (
          <Row row className="shipping-row">
            <Label for="carrier" sm={4}>
              {utils.toTitleCase(key)}:
            </Label>
            <Col sm={8}>
              <Input type="text" disabled value={val} />
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default ShippingBox;
